import React from 'react'
import cx from 'classnames';
import './style.css'

const FooterMenu = ({ className }) => (
  <div className={cx('home-footer-menu-links', className)}>
    <a href="https://community.drift.com/categories/developer">Community</a>
    <a href="https://www.drift.com">Drift.com</a>
    <a href="https://devdocs.drift.com">Docs</a>
  </div>
)

export default FooterMenu
